export default "__VITE_ASSET__BhcJO3OT__"